import React from 'react';
import { useSelector } from 'react-redux'
import styled from 'styled-components';

const StyledDiv = styled.div`
  width: 150px;
  height: 10px;
  @media (max-width: 576px) {
    width: 100px;
  }
  @media (min-width: 992px) {
    width: 200px;
  }
  .progress-bar {
    background-color: #25C1CD;
  }
`;

const ProgressBar = () => {
  const questions = useSelector(state => state.questions);
  const answers = useSelector(state => state.answers);
  const questionsCount = Object.keys(questions).reduce((total, k) => total + questions[k].length, 0);
  const answersCount = Object.keys(answers).length;
  return (
    <div className="d-flex align-items-center">
      <StyledDiv className="progress">
        <div
          className="progress-bar"
          role="progressbar"
          aria-valuenow={answersCount}
          aria-valuemin="0"
          aria-valuemax={questionsCount}
          style={{ width: `${answersCount / questionsCount * 100}%` }}
        />
      </StyledDiv>
      <span className="ml-2">{answersCount}/{questionsCount}</span>
    </div>
  );
};

export default ProgressBar;
